import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { HomepageImageCreateRequestBody, HomepageImageCreateResponse } from "./types";

export class HomepageImageCreateAPI extends BaseAPI<
    HomepageImageCreateRequestBody,
    HomepageImageCreateResponse
> {
    protected route = ApiRoutes.home_image.create;
    protected method = RequestMethod.POST;
    protected hasFile = true;

    protected prepareRequest(data: FormData): RequestInit {
        return {
            method: this.method,
            body: data,
        }
    }
}
